import { render, staticRenderFns } from "./TicketSidebar.vue?vue&type=template&id=5ee2a91a&scoped=true&"
import script from "./TicketSidebar.vue?vue&type=script&lang=js&"
export * from "./TicketSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TicketSidebar.vue?vue&type=style&index=0&id=5ee2a91a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee2a91a",
  null
  
)

export default component.exports